import React, { useRef, useEffect, useState } from 'react';
import './CameraCapture.css';

const CameraCapture = ({ onCapture, onClose }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (stream && videoRef.current) {
      videoRef.current.srcObject = stream;
      videoRef.current.play().catch(e => console.error("Video play failed:", e));
    }
  }, [stream]);

  useEffect(() => {
    const startCamera = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
        });
        setStream(mediaStream);
      } catch (err) {
        console.error("Error accessing camera:", err);
        setError("Kamera nije dostupna. Proverite dozvole u pregledaču.");
        // Fallback for browsers that don't support 'environment'
        if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') {
          try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
            setStream(mediaStream);
            setError(null);
          } catch (fallbackErr) {
            console.error("Error accessing fallback camera:", fallbackErr);
            setError("Kamera nije dostupna. Proverite dozvole u pregledaču.");
          }
        }
      }
    };

    startCamera();

    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  const handleCapture = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

      canvas.toBlob((blob) => {
        const now = new Date();
        const fileName = `capture-${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}-${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}.jpg`;
        
        const imageFile = new File([blob], fileName, { type: 'image/jpeg' });
        onCapture(imageFile);
        onClose();
      }, 'image/jpeg', 0.95);
    }
  };

  return (
    <div className="camera-modal" onClick={onClose}>
      <div className="camera-container" onClick={(e) => e.stopPropagation()}>
        {error ? (
          <div className="camera-error">
            <p>{error}</p>
            <button onClick={onClose} className="camera-button">Zatvori</button>
          </div>
        ) : (
          <>
            <video ref={videoRef} autoPlay playsInline className="camera-feed" />
            <canvas ref={canvasRef} style={{ display: 'none' }} />
            <div className="camera-controls">
              <button onClick={handleCapture} className="camera-button capture-button">
                Uslikaj
              </button>
              <button onClick={onClose} className="camera-button close-camera-button">
                Otkaži
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CameraCapture;